import { difference, isEqual, pullAt } from 'es-toolkit'

export const getNewLocalLanguagesPairs = (
  localLanguages?: Record<string, string[]> | null,
  serverLanguages?: Record<string, string[]>,
  lastSelectedLanguages?: [string, string],
): [string, string][] => {
  if (!localLanguages || !serverLanguages || !lastSelectedLanguages) return []

  if (isEqual(localLanguages, serverLanguages)) return []

  const newPairs = Object.entries(localLanguages).reduce(
    (acc, [source, learnLanguages]) => {
      const newLearnLanguages = difference(learnLanguages, serverLanguages[source] ?? [])
      if (!newLearnLanguages.length) return acc

      newLearnLanguages.forEach(learn => acc.push([source, learn]))

      return acc
    },
    [] as [string, string][],
  )

  const lastSelectedIndex = newPairs.findIndex(
    pair => pair[0] === lastSelectedLanguages[0] && pair[1] === lastSelectedLanguages[1],
  )

  if (lastSelectedIndex === -1) return newPairs

  pullAt(newPairs, [lastSelectedIndex])

  return [...newPairs, lastSelectedLanguages]
}
